import { FormHelperText } from "@mui/material"
import { Field, useFormikContext } from "formik"
import { CheckboxWithLabel } from "formik-mui"
import React from "react"
import styled from "styled-components"

const StyledContainer = styled.div<{ $isCentered?: boolean }>`
  position: relative;
  margin-bottom: 0.5em;
  display: flex;
  justify-content: ${(p) => (p.$isCentered ? "center" : "flex-start")};
  font-size: 12px;
  .Mui-focusVisible {
    border: 2px dashed white;
    outline: 3px dashed #0e3487;
    outline-offset: 2px;
  }
  .MuiTypography-root {
    font-size: 12px;
  }
  .MuiFormControlLabel-root {
    min-height: 100%;
    display: flex;
    align-items: center;
  }
`
const StyledCheckboxWithLabel = styled(CheckboxWithLabel)`
  .MuiFormControlLabel-label {
    align-self: center;
    font-size: 12px;
    line-height: 1.2;
    color: ${(p) => p.theme.palette.text.secondary};
  }
  .MuiFormControlLabel-label-273 {
    font-size: 12px;
  }
`

const StyledError = styled(FormHelperText)`
  position: absolute;
  bottom: -0.5em;
  right: 0;
`

type FormikCheckboxFieldProps = {
  name: string
  label: React.ReactNode
  required?: boolean
  inputRef?: React.RefObject<HTMLButtonElement>
  isCentered?: boolean
  className?: string
  labelStyles?: any
  classes?: any
}

const FormikCheckboxField = ({
  name,
  label,
  labelStyles,
  required,
  inputRef,
  isCentered,
  className,
  classes,
}: FormikCheckboxFieldProps) => {
  const { errors, touched } = useFormikContext<{ [field: string]: boolean }>()

  return (
    <StyledContainer $isCentered={isCentered} className={className}>
      <Field
        component={StyledCheckboxWithLabel}
        type="checkbox"
        color="primary"
        required={required}
        name={name}
        id={name}
        Label={{ label, style: { marginRight: 0 }, htmlFor: name }}
        inputRef={inputRef}
        inputProps={{
          "aria-describedby": `${name}-helper-text`,
          id: name,
        }}
        classes={classes}
      />
      {errors[name] && touched[name] && (
        <StyledError id={`${name}-helper-text`} error>
          {errors[name]}
        </StyledError>
      )}
    </StyledContainer>
  )
}

export default FormikCheckboxField
